import { gate } from 'hub-http/gates';
import { useIsUngated } from './useIsUngated';
export const useIsUngatedForCopilotV2 = () => {
  return useIsUngated(gate('Copilot:V2'));
};